/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Text,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Flex,
  Tooltip,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
} from "@chakra-ui/react";

import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { useDispatch, useSelector } from "react-redux";
import "./exportPdf.css";
import { IoClose } from "react-icons/io5";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { FaFileDownload } from "react-icons/fa";
import { fetchAsyncGetVendorByID } from "redux/vendorSlice";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { useToasts } from "react-toast-notifications";
import { Col, Row } from "react-bootstrap";
import { Divider } from "rsuite";
import GetAddress from "components/GetAddress";
import { getExpensePDF } from "api/expense";
import { GetCountries,GetState,GetCity, } from 'react-country-state-city';

const ShowAddress = ({address}) =>{
  const city = address?.cityName;
  const country = address?.countryName;
  const state = address?.stateName;
  return <>
    {address?.s1 && <p>{address?.s1}</p>}
    {address?.s2 && <p>{address?.s2}</p>}
    <p>{city ? `${city},` : ""}{state}</p>
    <p>{country ? country : ""}{address?.pin ? `,${address?.pin}` : ""}</p>
  </>
}

const PurchaseOrderPdf = (props) => {
  const { isOpen , onClose, expenseData,vendorGst,vendorId,gstType,itemList,gstAmount,total,adjustmentAmount,adjustmentLabel } = props;
  const [organizationData, setOrganizationData] = useState({});
  const [vendorDetail, setVendorDetail] = useState({});
  const organizationList = useSelector((state) => state.organizationData);
  const dispatch = useDispatch();
  const logoData = useSelector((state) => state.logoData);
  const logoUrl = logoData?.downloadUrl || "";
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);
  const [addresses,setAddresses] = useState();
  const [addressLoading,setAddressLoading] = useState(true);

  const fetchVendorDetails = async (vendorId) => {
    setLoading(true);
    try {
      const res = await dispatch(fetchAsyncGetVendorByID(vendorId));
      if (res?.payload) {
        setVendorDetail(res.payload.vendor);
      }
    } catch (error) {
      addToast(`Error fetching vendor details:`, { appearance: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vendorId ) {
      fetchVendorDetails(vendorId);
    }
  }, [vendorId]);

 
  useEffect(() => {
    if (organizationList && organizationList?.length) {
      const data = organizationList[0];
      setOrganizationData(data);
    }
  }, [organizationList]);

  const TermsAndConditions = ({ organizationData }) => {
    const tq = organizationData?.tc || "";
    const termsArray = tq.split('\n').filter(term => term.trim() !== "") || [];
    return (
      <>
        {termsArray.length > 0 && (
          <>
            <Text>Terms & Conditions</Text>
            {termsArray.map((term, index) => {
              const trimmedTerm = term.trim();
              return trimmedTerm ? (
                <Text className="terms-text" key={index}>
                  {trimmedTerm}
                </Text>
              ) : null;
            })}
          </>
        ) }
      </>
    );
  };
 
  const handlePdf = async () => {
    const {orgAddress, vendorAddress} = addresses || {};
    try {
      const poNo = poNumberFormate(expenseData?.poNo);
      await getExpensePDF({
        ...props,
        organizationData: {
          ...organizationData,
          add: orgAddress,
        },
        vendorDetail: {
          ...vendorDetail,
          blAd: vendorAddress
        },
        logoUrl,
        expenseData: {
          ...expenseData,
          poNo,
        },
      }, expenseData?.poNo && `${poNo}.pdf`);
    } catch (error) {
      console.error(error);
      addToast('Error downloading document', {appearance: 'error'});
    }
  };

  const fetchAndSetAddresses=useCallback(async()=> {
    if (loading) return;
    setAddressLoading(true)
    try {
      const [orgAddress, vendorAddress] = await fetchAddressDetails(organizationData?.add, vendorDetail?.blAd);
      setAddresses({orgAddress, vendorAddress});
    } finally {
      setAddressLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  useEffect(() => {
    fetchAndSetAddresses()
  }, [fetchAndSetAddresses]);

  const fetchAddressDetails = async (...addresses) => {
    const cache = {
      countries: null,
      states: {},
      cities: {},
    };

    cache.countries = await GetCountries() || [];

    const results = await Promise.all(
      addresses.map(async (address) => {
        if (!address) return {}
        const countryId = address?.ctr || 101;
        const stateId = address.st || null;
        const cityId = address.ct || null;

        const country =
          cache.countries.find(c => c.id === countryId);

        if (!cache.states[countryId]) {
          cache.states[countryId] = GetState(countryId) || [];
        }
        const state =
          (await cache.states[countryId]).find(s => s.id === stateId);

        const cityKey = `${countryId}_${stateId}`;
        if (stateId && !cache.cities[cityKey]) {
          cache.cities[cityKey] = GetCity(countryId, stateId) || [];
        }
        const city =
          (await cache.cities[cityKey])?.find(c => c.id === cityId);

        return {
          ...address,
          countryName: country?.name || "",
          stateName: state?.name || "",
          cityName: city?.name || ""
        };
      })
    );
  
    return results;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="modal-main" size="xl">
      <ModalOverlay />
      <ModalContent
        className="add-form-modal-content"
        top="0"
        margin="0 auto"
        bottom="0"
      >
        <div className="fixed-header  mt-0">
          <Box className="payment-template">
            <Tooltip
              label="Close"
              placement="bottom"
              hasArrow
              className="common-tooltip"
            >
              <button className="close-btn" onClick={onClose}>
                <IoClose />
              </button>
            </Tooltip>
            <Tooltip
              label="Download"
              placement="bottom"
              hasArrow
              className="common-tooltip"
            >
              <button onClick={handlePdf} disabled={addressLoading} title={addressLoading ? "Please wait while the data is loading" : undefined} className="pdf-downlode-icon">
                <FaFileDownload />
              </button>
            </Tooltip>
          </Box>
        </div>
        <ModalBody>
          <>
            <Box className="purchase-order-pdf">
              {addressLoading ? (
                <SpinnerLoader />
              ) : (
                <>
                  <Box id="pdf-content" className="main-template">
                    <Box display="flex" justifyContent="space-between" className="purchase-order-header" >
                      <Flex
                        // align="center"
                        direction="row"
                        className="payment-pdf-logo mb-0"
                      >
                        <img src={logoUrl} alt="logo" />
                      </Flex>
                      <Box className="top-heading">
                        <Text className="heading-text">Purchase Order</Text>
                        <Text className="poNo-text mt-2 text-end">
                          # {poNumberFormate(expenseData?.poNo)}
                        </Text>
                      </Box>
                    </Box>
                    <Box
                      display="flex"
                      className="payment-pdf-header"
                      justifyContent="space-between"
                    >
                      <div className="header-box">
                        <Text className="title">{organizationData?.name}</Text>
                        <Text className="address">
                          <ShowAddress address={addresses?.orgAddress} />
                        </Text>
                        <Text className="address">
                          <span>Company ID :</span>
                          <span> {organizationData?.cpId}</span>
                        </Text>
                        <Text className="address">
                          <span> GSTIN :</span>
                          <span> {organizationData?.gstNo}</span>
                        </Text>
                      </div>
                    </Box>
                    <Box className="vendor-address-box">
                      <Box
                        display="flex"
                        className="payment-pdf-header"
                        justifyContent="space-between"
                      >
                        <div className="header-box">
                          <Text className="address">Vendor Address</Text>
                          <Text className="title">{vendorDetail?.name}</Text>
                          <Text className="address">
                            <ShowAddress address={addresses?.vendorAddress} />
                          </Text>

                          <Text className="address">
                            <span> GSTIN :</span>
                            <span> {vendorGst}</span>
                          </Text>
                        </div>
                      </Box>
                      <Box className="order-details">
                        <div className="order-details-list">
                          <div className="list-heading">PO Number :</div>
                          <div className="list-value text-end">
                            {poNumberFormate(expenseData?.poNo)}
                          </div>
                        </div>
                        <div className="order-details-list">
                          <div className="list-heading">PO Date :</div>
                          <div className="list-value text-end">
                            {dateTimeFormat(expenseData?.oDt)}
                          </div>
                        </div>
                        <div className="order-details-list">
                          <div className="list-heading">Delivery Date :</div>
                          <div className="list-value text-end">
                            {expenseData?.imDate
                              ? "Immediate"
                              : dateTimeFormat(expenseData?.dlDt)}
                          </div>
                        </div>
                      </Box>
                    </Box>
                    <div className="payment-table-box ">
                      <Table>
                        <Thead>
                          <Tr>
                            <Th width={8}>#</Th>
                            <Th width={340}>Item & Description </Th>
                            <Th className="text-end">HSN/SAC</Th>
                            <Th className="text-end">Qty</Th>
                            <Th className="text-end">Rate </Th>
                            <Th className="text-end">Amount</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {itemList &&
                            itemList?.length &&
                            itemList.map((item, i) => {
                              return (
                                <Tr>
                                  <Td>{i + 1}</Td>
                                  <Td className="item-data">
                                    <Text className="name">
                                      {item?.slItm?.name}
                                    </Text>
                                    <Text className="description">
                                      {item?.slItm?.dc}
                                    </Text>
                                  </Td>
                                  <Td className="text-end">
                                    {item?.slItm?.hCd || item?.slItm?.sCd}
                                  </Td>
                                  <Td className="text-end">{item?.qty}</Td>
                                  <Td className="text-end">
                                    {formatAmountInINR(item?.prc || 0)}
                                  </Td>
                                  <Td className="text-end">
                                    {formatAmountInINR(item?.amt || 0)}
                                  </Td>
                                </Tr>
                              );
                            })}
                        </Tbody>
                      </Table>
                    </div>
                    <Box className="total-details">
                      <Row>
                        <Col className="col-lg-8"></Col>
                        <Col>
                          <div className="total-amount-details">
                            <div className="heading">Sub Total</div>
                            <div className="value text-end">
                              {formatAmountInINR(total?.amt || 0)}
                            </div>
                          </div>
                          {gstType === "IGST" ? (
                            <div className="total-amount-details">
                              <div className="heading">IGST</div>
                              <div className="value text-end">
                                {formatAmountInINR(gstAmount?.i || 0)}
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="total-amount-details">
                                <div className="heading">SGST</div>
                                <div className="value text-end">
                                  {formatAmountInINR(gstAmount?.s || 0)}
                                </div>
                              </div>
                              <div className="total-amount-details">
                                <div className="heading">CGST</div>
                                <div className="value text-end">
                                  {formatAmountInINR(gstAmount?.c || 0)}
                                </div>
                              </div>
                            </>
                          )}
                          {adjustmentAmount ? (
                            <div className="total-amount-details">
                              <div className="heading">{adjustmentLabel}</div>
                              <div className="value text-end">
                                {formatAmountInINR(adjustmentAmount || 0)}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div
                            className="total-amount-details final-amount  pt-1"
                            style={{ borderTop: "1px solid #E2E8F0" }}
                          >
                            <div className="heading text-bold">Total</div>
                            <div className="value text-bold text-end">
                              {formatAmountInINR(
                                total?.amt +
                                  total?.gstAmt +
                                  Number(adjustmentAmount || 0)
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Box>
                    <Box className="terms-condtions">
                      <TermsAndConditions organizationData={organizationData} />
                    </Box>
                    <Box className="pdf-footer" id="po-footer">
                      <Divider className="footer-divider" />
                      <Text className="footer-text">
                        {organizationData?.fTxt}
                      </Text>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PurchaseOrderPdf;
